import { useMemo } from "react";
import styles from "./styles.module.scss";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import cn from "clsx";

export default function LeaderCard({ item, hasFixWidth = false }) {
  const img = useMemo(() => {
    return strapiSingleAttribute(item?.attributes?.Image?.source);
  }, [item?.attributes?.Image]);

  return (
    <div
      className={cn(styles.root, {
        [styles.fixWidth]: hasFixWidth,
      })}
    >
      {item?.attributes?.Image?.enabled ? (
        <img
          src={img?.url}
          alt={item?.attributes?.Image?.alt || 'Leader Image'}
          title="Leader Image"
          className={styles.img}
        />
      ) : null}

      <div className={styles.textContainer}>
        {item?.attributes?.Name?.enabled ? (
          <h6 className={styles.name}>{item?.attributes?.Name?.text}</h6>
        ) : null}
        {item?.attributes?.Designation?.enabled ? (
          <p className={styles.desg}>
            {item?.attributes?.Designation?.text?.replace(/\n/gi, "  \n")}
          </p>
        ) : null}
      </div>
    </div>
  );
}
